import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { auth } from './config/firebase';
import Landing from './pages/landing';
import ImageLayout from './pages/imageLayout';
import GraphicsLayout from './pages/graphicLayout';
import VideoLayout from './pages/videoLayout';
import Login from './pages/login';
import Upload from './pages/upload';
import Contact from './pages/contact';
import TermsAndConditions from './pages/termsAndConditions';
import Tags from './pages/tags';

import './App.css';

const App = () => {
  const [ currentUser, setCurrentUser ] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if(authUser){
        setCurrentUser(authUser)
      } else {
        setCurrentUser(null);
      }
    })

    return () => {
      unsubscribe();
    }
  }, [currentUser]);

  
    let content;
    if (currentUser){
     content = (
        <React.Fragment>
          <Route path="/login/cinecomaidin/admin-access" render={()=><Redirect to="/upload/cinecomaidin/admin-access"/>} />
          <Route path="/upload/cinecomaidin/admin-access" exact><Upload user={currentUser} /></Route>
        </React.Fragment>
      )
    } else if (!currentUser) {
      content =  (
        <React.Fragment>
          <Route path="/login/cinecomaidin/admin-access" exact><Login user={currentUser} /></Route>
          <Route path="/upload/cinecomaidin/admin-access" render={()=><Redirect to="/login/cinecomaidin/admin-access"/>} />
        </React.Fragment>
      )
    }
    return (
        <BrowserRouter>
          <div>
            <Switch>
              <Route path="/" exact><Landing  /></Route>
              <Route path="/view-images" exact><ImageLayout /></Route>
              <Route path="/view-graphics" exact><GraphicsLayout /></Route>
              <Route path="/view-videos" exact><VideoLayout /></Route>
              <Route path="/contact" exact><Contact /></Route>
              <Route path="/terms-and-conditions" exact><TermsAndConditions /></Route>
              <Route path="/seo/tags/h1" exact><Tags /></Route>
              {content}
            </Switch>
          </div>
        </BrowserRouter>
    );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js